import React from 'react';

//Components
import Credenciais from '../../../../containers/credencial/credenciamento/Credenciais';
import Body from '../../../../components/layoutcredenciamento/Body';
import Header from '../../../../components/layoutcredenciamento/Header';
import Footer from '../../../../components/layoutcredenciamento/Footer';
import Layout from '../../../../components/layoutcredenciamento/Layout';

const Credencial  = () => {                    
    return (
        <Layout>
            <Header categoriafixada={true} getCategoria={null} getLinguagem={null} pagina="credencial" prelogin={false} />
            <Body>
                <Credenciais  />
            </Body>
            <Footer />
        </Layout>
    )    
}

export default Credencial;